export default {
  header: 'Tools',
  tabs: {
    qr: 'QR',
    abv: 'ABV',
    honey: 'Honey',
    bottleSlider: 'Bottle Slider',
  },
  totalLiters: 'Total Liters',
  placeholderLiters: 'Enter total liters',
  bottleSizes: 'Bottle Sizes (L)',
  adjustSlider: 'Adjust the slider to see how many bottles you need.',
};
